import React from 'react'
import { HeadingProps, Heading } from '@chakra-ui/react'

export const OnboardingHeading: React.FC<HeadingProps> = props => (
  <Heading color="#373F49" as="h3" size="lg" fontWeight="normal" {...props} />
)
